import React, { useState, useEffect } from 'react';
import { crmAPI } from '../../services/api';
import CRMLayout from './CRMLayout';

const CRMStaffManagement = () => {
  const [staff, setStaff] = useState([]);
  const [form, setForm] = useState({ name: '', username: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const loadStaff = async () => {
    try {
      const res = await crmAPI.getStaff();
      setStaff(res.data);
    } catch {}
  };

  useEffect(() => { loadStaff(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setSuccess('');
    try {
      await crmAPI.createStaff(form);
      setSuccess(`"${form.name}" аккаунти яратилди`);
      setForm({ name: '', username: '', password: '' });
      setShowForm(false);
      loadStaff();
    } catch (err) {
      setError(err.response?.data?.error || 'Хатолик');
    } finally {
      setLoading(false);
    }
  };

  return (
    <CRMLayout>
      <div style={{ padding: '2rem', maxWidth: '800px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1a365d' }}>Ходимлар</h1>
          <button onClick={() => setShowForm(p => !p)} style={btnStyle('#1a365d')}>
            {showForm ? 'Бекор қилиш' : '+ Янги ходим'}
          </button>
        </div>

        {success && <div style={alertStyle('#f0fff4', '#276749')}>{success}</div>}
        {error && <div style={alertStyle('#fed7d7', '#c53030')}>{error}</div>}

        {showForm && (
          <form onSubmit={handleCreate} style={{ backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0', marginBottom: '1.5rem' }}>
            <h2 style={{ fontSize: '1rem', fontWeight: '700', color: '#1a365d', marginBottom: '1rem' }}>Янги ходим аккаунти</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
              <div>
                <label style={labelStyle}>Исм *</label>
                <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Фойдаланувчи номи *</label>
                <input value={form.username} onChange={e => setForm(p => ({ ...p, username: e.target.value }))} required style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <label style={labelStyle}>Парол *</label>
              <input type="password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} required style={inputStyle} />
            </div>
            <button type="submit" disabled={loading} style={btnStyle(loading ? '#a0aec0' : '#38a169')}>
              {loading ? 'Сақланмоқда...' : 'Яратиш'}
            </button>
          </form>
        )}

        <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f7fafc' }}>
                <th style={th}>Исм</th>
                <th style={th}>Фойдаланувчи номи</th>
                <th style={th}>Яратилган сана</th>
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr><td colSpan={3} style={{ textAlign: 'center', padding: '2rem', color: '#718096' }}>Ходимлар йўқ</td></tr>
              ) : staff.map(s => (
                <tr key={s.id} style={{ borderTop: '1px solid #f0f4f8' }}>
                  <td style={td}>{s.name}</td>
                  <td style={td}>{s.username}</td>
                  <td style={td}>{new Date(s.created_at).toLocaleDateString('uz-UZ')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </CRMLayout>
  );
};

const btnStyle = (bg) => ({
  backgroundColor: bg, color: 'white', border: 'none',
  padding: '0.6rem 1.25rem', borderRadius: '8px', fontSize: '0.9rem',
  fontWeight: '600', cursor: 'pointer',
});
const alertStyle = (bg, color) => ({
  backgroundColor: bg, color, padding: '0.75rem 1rem',
  borderRadius: '8px', marginBottom: '1rem', fontSize: '0.9rem',
});
const labelStyle = { display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#4a5568', marginBottom: '0.35rem' };
const inputStyle = { width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' };
const th = { padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.8rem', fontWeight: '600', color: '#718096', textTransform: 'uppercase' };
const td = { padding: '0.75rem 1rem', fontSize: '0.9rem', color: '#2d3748' };

export default CRMStaffManagement;
